import { type CallhomeAiTag } from '@solinkcorp/api-types';
import { Badge } from '@solinkcorp/solink-ui/components/Badge';
import React from 'react';

interface WidgetTagBadgesProps {
  tags: readonly CallhomeAiTag[];
}

const WidgetTagBadges: React.FC<WidgetTagBadgesProps> = ({ tags }) => (
  <div className="inline-flex shrink-0 gap-1">
    {tags.map((t: CallhomeAiTag) => (
      <Badge key={t.id} variant="video" data-testid="sdm-widget-tag-badge">
        {t.name}
      </Badge>
    ))}
  </div>
);

export default WidgetTagBadges;
